// hooks/useComplaintTaxonomy.js - The complaint choice lists, fetched once per app session.
// The server file complaintTaxonomy.js is the single source; the client never hardcodes
// a list, so a wording change there reaches every screen without a client release.
import { useEffect, useState } from 'react';
import api from '../utils/api';

let cache = null;
let inflight = null;

export function loadComplaintTaxonomy() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get('/api/complaints/taxonomy')
      .then(({ data }) => { cache = data; return data; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export default function useComplaintTaxonomy() {
  const [taxonomy, setTaxonomy] = useState(cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache) return;
    let alive = true;
    loadComplaintTaxonomy()
      .then((t) => { if (alive) setTaxonomy(t); })
      .catch((e) => { if (alive) setError(e); });
    return () => { alive = false; };
  }, []);

  return { taxonomy, error };
}
